import { DocumentServicesObject, CompRef } from '@wix/document-services-types';

export function getAppData(
  documentServicesAPI: DocumentServicesObject,
  widgetCompRef: CompRef,
): { widgetId: string; appDefinitionId: string } {
  const type = documentServicesAPI.components.getType(widgetCompRef);

  if (type.startsWith('platform.builder')) {
    const builderCompData =
      documentServicesAPI.builder.components.getCompAppData(type);
    if (!builderCompData?.componentId || !builderCompData?.appDefinitionId) {
      throw new Error('Builder component data is not valid');
    }
    return {
      widgetId: builderCompData?.componentId,
      appDefinitionId: builderCompData?.appDefinitionId,
    };
  }

  const { appDefinitionId, widgetId } =
    documentServicesAPI.components.data.get(widgetCompRef);
  if (!widgetId || !appDefinitionId) {
    throw new Error('component data is not valid');
  }
  return {
    widgetId,
    appDefinitionId,
  };
}
